import { mapGetters } from 'vuex';
import ScanProcess from '@/modules/scan-process';
import ApiActions from '@/modules/api-actions';
import PoseDetector from '@/modules/PoseDetector';
import { EVENTS } from '@/events/hardware';

const leave = {
  methods: {
    leave(errorMessage) {
      console.log('leaving scan process...');
      if (typeof errorMessage === 'string') {
        console.log('leaving with error...', errorMessage);
      }
      // 中途放棄的話沒人收 preload 的 wasm；沒 preload 過就是 no-op
      PoseDetector.close();
      if (ScanProcess.isOngoing()) {
        const { scannerId } = ScanProcess;
        ScanProcess.cancel().then(() => {
          if (typeof this.stopArmDetection === 'function') {
            this.stopArmDetection(scannerId);
          }
          if (this.isContactless) {
            ApiActions.user.logout();
          }
          this.$events.emit(EVENTS.START_BT_SCAN, true);
          setTimeout(() => {
            this.$events.emit(EVENTS.STOP_BT_SCAN);
          }, 300);
        });
      }
      const params = typeof errorMessage === 'string' ? { error: errorMessage } : {};
      this.$events.goto(this.isContactless ? 'Welcome' : 'HomePage', { params });
    },
  },
  computed: {
    ...mapGetters('mtmUser', ['isContactless']),
  },
};

export default leave;
